/* eslint-disable react/display-name */

import { ComponentType } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18next from '../services/i18n';

export function withLocalize<Props extends object>(WrappedComponent: ComponentType<Props>) {
  return (props: Props) => (
    <I18nextProvider i18n={i18next}>
      <WrappedComponent {...props as Props} />
    </I18nextProvider>
  );
}
